import Vue from 'vue';
import App from './App.vue';

window.initEntrance = ({el, entranceConfig, baseFontColor}) => {
	new Vue({
		el,
		render: h => h(App, {
			props: {
				type: entranceConfig.type,
				layers: entranceConfig.layers,
				baseFontColor: baseFontColor
			},
		}),
	});
};
